import React from 'react'
import BlockBasic from '../blocks/BlockBasic';
import BlockBasicCol from '../blocks/BlockBasicCol';
import BlockBasicEmptyCol from '../blocks/BlockBasicEmptyCol';

const BlockLoader = ( { item, collectionSettings } ) => {
    const blockMap = {
        BlockBasic,
        BlockBasicCol,
        BlockBasicEmptyCol
    }
    let Component = blockMap[item.component] || null
    if(Component) {
        return (
            <Component
                key={item.id}
                settings={item.settings}
                contentType={item.contentType}
                contentCollection={item.contentCollection}
                collectionSettings={collectionSettings}
            />
        )
    } else {
        console.log(`Compontent ${item.component} not found`)
    }
}

export default BlockLoader